// extracted by mini-css-extract-plugin
export default {"curiosityFooter":"CuriosityFooter_curiosityFooter__EahFd"};